<template>
  <div class="languages-menu">
        <div class="language-current" @click="openMenu">{{currentLanguage}}</div>
        <ul class="languages-list drop-shadow" :class="[(active ? 'active': '')]">
            <li v-for="lang in languages" class="language" :key='lang.getName()' @click="changeLanguage(lang)" :class='["lang-" + lang.getName(), { "active": lang.getName() == language}]'>
                <label>{{getLanguage(lang)}}</label>
            </li>
        </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
const languageTo3 = {
    et: "EST",
    en: "ENG",
    fi: "FIN",
    ru: "RUS"
}
export default {
    computed: {//yahLogo
		...mapState('wf', ['languages', 'language']),
        currentLanguage () {
            return languageTo3[this.language];
        }
	},
    data () {
		return {
            active: false
        }
    },
    methods: {
        openMenu () {
            this.active = !this.active;
        },
        getLanguage (lang) {
            return languageTo3[lang.name];
        },
        changeLanguage (language) {
			if (this.$listeners && this.$listeners.changeLanguage) {
				this.$emit("change", language);
			}
			else {
				this.$wayfinder.setLanguage(language.name);
			}
            this.active = false;
		},
    }
}
</script>

<style lang="less">
    @import '../css/variables';
    @import '../css/responsive';

   .languages-menu {
        width: auto;
        font-size: 1.8rem;
        line-height: 1.4;
        position: relative;
        display: flex;
        align-items: center;

        .language-current {
            color: @active-color;
            text-transform: uppercase;
        }

        .languages-list {
            width: 0;
            height: 0;
            position: absolute;
            bottom: 0;
            padding: 0;
            font-size: 1.6rem;
            background-color: transparent;
            box-shadow: 0px 22px 26px -10px rgba(0,0,0, 0.25);
            transition: width 0.3s, height 0.3s, opacity 0.1s;
            font-size: 0;
            opacity: 0;
            z-index: 1;

            .lang-fi {
                display: none;
            }

            &::after {
                width: 0.9rem;
                height: 0.9rem;
                content: ' ';
                position: absolute;
                bottom: -0.45rem;
                transform: rotate(45deg);
                display: block;
                left: 0.1rem;
                background-color: white;
                box-shadow: 3px 3px 7px rgb(0 0 0 / 1%);
                opacity: 0;
                transition: opacity 0.2s;
            }

            &.active {
                width: auto;
                height: auto;
                background-color: white;
                padding: 2.5rem 5.5rem;
                font-size: 1.6rem;
                opacity: 1;
                bottom: 8rem;

                &::after {
                    opacity: 1;
                }
            }
        }

        ul {
            list-style: none;
            text-transform: uppercase;
            margin: 0;
            padding: 0;
            height: 100%;
            font-weight: 500;
        }

        li {
            vertical-align: baseline;
            padding: 0.8rem 0;
        }

        li.active {
            color: @active-color;
            list-style-type: initial;
        }
    }

    @media @landscape {
        .languages-list {
            right: 3rem;
            bottom: 10rem;

            &::after {
                right: 0.1rem;
                left: revert !important;
            }
        }
    }
</style>